if (!customElements.get('limited-drops')) {
  customElements.define(
    'limited-drops',
    class LimitedDrops extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableMobileSlider !== 'true') return;

        this.grid = this.querySelector('.gh-drops__grid');
        this.prevBtn = this.querySelector('.gh-drops__nav--prev');
        this.nextBtn = this.querySelector('.gh-drops__nav--next');
        this.track = this.querySelector('.gh-drops__scrollbar');
        if (!this.grid) return;

        this.mql = window.matchMedia('(max-width: 767px)');

        this.initArrows();
        this.initProgressBar();
      }

      isMobile() {
        return this.mql.matches;
      }

      step(direction) {
        const first = this.grid.children[0];
        let size = this.grid.clientWidth * 0.8;
        if (first) {
          const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
          size = first.getBoundingClientRect().width + gap;
        }
        return size * direction;
      }

      initArrows() {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            if (this.isMobile()) this.grid.scrollBy({ left: this.step(-1), behavior: 'smooth' });
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            if (this.isMobile()) this.grid.scrollBy({ left: this.step(1), behavior: 'smooth' });
          });
        }
      }

      initProgressBar() {
        if (!this.track) return;

        let drag = this.track.querySelector('.swiper-scrollbar-drag');
        if (!drag) {
          drag = document.createElement('div');
          drag.className = 'swiper-scrollbar-drag';
          this.track.appendChild(drag);
        }

        const g = this.grid;

        const update = () => {
          if (!this.isMobile()) return;
          const scrollable = g.scrollWidth - g.clientWidth;
          const thumb = Math.min(100, Math.max(10, (g.clientWidth / g.scrollWidth) * 100));
          const progress = scrollable > 0 ? g.scrollLeft / scrollable : 0;
          drag.style.display = scrollable > 1 ? 'block' : 'none';
          // Fill-style progress bar: grows left-to-right as you advance
          drag.style.width = (thumb + progress * (100 - thumb)) + '%';
        };

        g.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        window.addEventListener('load', update, { once: true });
        requestAnimationFrame(update);

        // Draggable -> drives native scroll position
        let dragging = false;
        let startX = 0;
        let startScroll = 0;

        const onDown = (e) => {
          if (!this.isMobile()) return;
          dragging = true;
          startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
          startScroll = g.scrollLeft;
          e.preventDefault();
        };
        const onMove = (e) => {
          if (!dragging || !this.isMobile()) return;
          const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
          const dx = clientX - startX;
          const trackWidth = this.track.getBoundingClientRect().width;
          const scrollable = g.scrollWidth - g.clientWidth;
          const thumb = (g.clientWidth / g.scrollWidth) * trackWidth;
          const range = Math.max(1, trackWidth - thumb);
          g.scrollLeft = startScroll + (dx / range) * scrollable;
          e.preventDefault();
        };
        const onUp = () => { dragging = false; };

        drag.addEventListener('mousedown', onDown, { passive: false });
        drag.addEventListener('touchstart', onDown, { passive: false });
        document.addEventListener('mousemove', onMove, { passive: false });
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchend', onUp);
      }
    }
  );
}
